import 'angular';
import modal from 'angular-ui-bootstrap';
import '../../../../../lib/assets/javascripts/devex/util';
import routesModule from '../../../utilities/routes_module';
import template from './report_contacts.template.html?raw';
import emailFormModalTemplate from '../modals/email_form_modal.template.html?raw';

const modalDependencies = [modal];

angular
  .module('fundingSearchApp.directives.reportContacts', modalDependencies)
  .run(['$templateCache', ($templateCache) => {
    $templateCache.put(template, template);
    $templateCache.put(emailFormModalTemplate, emailFormModalTemplate);
  }])
  .directive('reportContacts', [
    '$uibModal',
    '$http',
    ($uibModal, $http) => {
      const link = ($scope) => {
        $scope.organizationDetailsUrl = (id) => routesModule.organization_path(id);

        let myModal = null;
        $scope.subjectField = true;
        $scope.selectedContact = null;
        $scope.subject = '';
        $scope.message = '';

        $scope.showModal = (index) => {
          $scope.selectedContact = $scope.report.contacts[index];
          $scope.modalTitle = 'Message contact';
          $scope.ctaButtonText = 'Send Email';
          $scope.email = $scope.selectedContact.email;

          myModal = $uibModal.open({
            templateUrl: emailFormModalTemplate,
            scope: $scope,
            animation: false,
          });
        };

        $scope.sendEmail = () => {
          $scope.loading = true;

          const payload = {
            contact_id: $scope.selectedContact.id,
            report_type: $scope.report.type,
            subject: $scope.subject,
            message: $scope.message,
          };

          const apiPath = routesModule.api_procurements_contact_partner_path({
            report_type: devex.util.classToRestPlural($scope.report.type),
            report_id: $scope.report.id,
          });

          $http
            .post(apiPath, payload)
            .then(() => {
              devex.alerts.showAlert('Email sent successfully', 'success');
            })
            .catch((error) => {
              devex.alerts.showAlert(`Error sending email: ${error}`, 'error');
            })
            .finally(() => {
              $scope.loading = false;
              myModal.close();
            });
        };
      };

      return {
        restrict: 'E',
        templateUrl: template,
        scope: {
          report: '=',
          userPermissions: '=',
        },
        link,
      };
    },
  ]);
